import { combineReducers } from '@reduxjs/toolkit';
import channels from './ChannelReducer';
import logs from './DeliveryLogsReducer.ts';

const ChannelReducer = combineReducers({
  channels,
  logs,
});

export default ChannelReducer;
